import { Route, Switch, useRouteMatch } from 'react-router-dom'

import NotFound from 'errorPages/NotFound'

import { ROUTE_PATHS } from '../../../common/routePaths'
import GetReimbursed from '../../common/getReimbursed'
import Summary from './summary'

const Dashboard = () => {
  let match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${ROUTE_PATHS.ELIGIBLE_EMPLOYEE_GET_REIMBURSED}`} component={GetReimbursed} />
      <Route path={`${match.path}`} component={Summary} />
      <Route>
        <NotFound />
      </Route>
    </Switch>
  )
}

export default Dashboard
